import { useEffect, useState } from 'react';

export const useLoading = (loading: boolean, timeout?: number) => {
  const [loadingState, setLoadingState] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(true);

  useEffect(() => {
    if (!isInitialRender) {
      setLoadingState(true);
    }

    if (loading) return;

    const _setTimeout = setTimeout(() => {
      setLoadingState(false);
      setIsInitialRender(false);
    }, timeout ?? 200);

    return () => {
      clearTimeout(_setTimeout);
    };
  }, [loading, timeout, isInitialRender]);

  return [loadingState];
};
